import { ImportFormatDataType, ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { InputFormatProvider } from './InputFormatProvider';
import { EntityListSkuInputData } from '../entityListTypes';

export class SkuInputFormatProvider extends InputFormatProvider<EntityListSkuInputData> {
  getInputFormat(): ImportFormatItem<EntityListSkuInputData>[] {
    return [
      {
        id: 'product',
        label: 'Product ID',
        dataType: ImportFormatDataType.STRING,
      },
      {
        id: 'store',
        label: 'Store ID',
        dataType: ImportFormatDataType.STRING,
      },
    ];
  }
}
